export default  {
    methods: {
        getSensorDesc(varName,equipmentName){
            for (let point of this.$store.state.pointsListStore.pointsList.points_list){
                if(point.sensor_name===varName&&point.equipment_name===equipmentName){
                    if(point.sensor_desc&&point.sensor_desc!==""){return point.sensor_desc}
                    break
                }
            }
            return null;
        },
    }
};